<template>



    <div class="w1200 audition-page">



        <div class="audition-lottery audition-lottery-top">

            <div class="lottery-tabs">

                <span

                    v-for="item in lotteryOptions"

                    :key="item.dictValue"

                    :class="{ active: lotteryActive === item.dictValue }"

                    @click="toggleLottery(item.dictValue)">{{ item.dictLabel }}</span>

            </div>

            <span class="intro-trigger" @click="introVisible = true">活动介绍</span>

        </div>



        <period-summary :period="period" :lottery-options="lotteryOptions" show-empty />

        <el-dialog title="活动介绍" :visible.sync="introVisible" width="640px" append-to-body>
            <ul class="intro-list">
                <li>仅支持双色球与大乐透前区（红球），面向认证用户征集万元级实战投注单（约 9,500～10,500 元）。</li>
                <li>开奖后按红球/前区命中个数计算本期积分：双色球 6 个=二等奖金额、5 个=200、4 个=10、3 个=5；大乐透前区 5 个=二等奖金额、4 个=200、3 个=10、2 个=5。</li>
                <li>排名依据往期累计，积分越高越靠前；多组红表/前区条件取最大命中数。</li>
                <li>认证缩水师/技巧师或满足条件的用户可提交方案，审核通过后参与当期排行。</li>
            </ul>
        </el-dialog>

        <div class="audition-toolbar">



            <div class="toolbar-right">



                <el-select v-model="sort" size="small" style="width:130px">



                    <el-option label="往期累计" value="score" />



                    <el-option label="本期积分" value="period" />



                    <el-option label="最新" value="latest" />



                    <el-option label="奖金预期" value="prize" />



                </el-select>



                <span class="apply_sss primary" :class="{ disabled: !periodOperable }" @click="goSubmit">提交方案</span>



                <span class="apply_sss" @click="goBack">返回栏目</span>



            </div>



        </div>







        <entry-rank-list



            :period-id="periodId"



            :period-name="periodName"



            :lottery-options="lotteryOptions"



            :lottery-active="lotteryActive"



            :sort="sort"



            @period-nav="handlePeriodNav" />



    </div>



</template>







<script>



import { getLatestPeriod, getAdjacentPeriod } from '@/api/audition'



import { queryLotteryType } from '@/api/common'



import PeriodSummary from './components/PeriodSummary.vue'



import EntryRankList from './components/EntryRankList.vue'



import { isPeriodOperable, ALLOWED_PRE_TYPES, filterAuditionLotteryOptions, hxwyszHomeLocation } from './utils'

export default {



    components: { PeriodSummary, EntryRankList },



    data () {



        return {



            period: null,



            periodId: null,



            periodName: '',



            lotteryOptions: [],



            lotteryActive: '',



            sort: 'score',



            introVisible: false



        }



    },



    computed: {



        periodOperable () {



            return isPeriodOperable(this.period)



        }



    },



    mounted () {



        const q = this.$route.query



        if (q.sort) this.sort = q.sort



        if (q.preType) this.lotteryActive = q.preType



        this.loadLotteryTypes().then(() => {



            this.initPeriod()



        })



    },



    methods: {



        goBack () {

            this.$router.push(hxwyszHomeLocation(this.lotteryActive))

        },



        loadLotteryTypes () {



            return queryLotteryType().then(res => {



                if (res && res.code === 200) {



                    this.lotteryOptions = filterAuditionLotteryOptions(res.data)

                    if (!this.lotteryActive && this.lotteryOptions.length) {

                        this.lotteryActive = this.lotteryOptions[0].dictValue

                    } else if (this.lotteryActive && !ALLOWED_PRE_TYPES.includes(this.lotteryActive)) {

                        this.lotteryActive = this.lotteryOptions.length ? this.lotteryOptions[0].dictValue : ''

                    }



                }



            }).catch(() => {})



        },



        applyPeriod (data) {



            if (data) {



                this.period = data



                this.periodId = data.id



                this.periodName = data.periodName



            } else {



                this.period = null



                this.periodId = null



                this.periodName = ''



            }



        },



        initPeriod () {



            if (!this.lotteryActive) return



            getLatestPeriod(this.lotteryActive).then(res => {



                if (res && res.code === 200 && res.data) {



                    this.applyPeriod(res.data)



                } else {



                    this.applyPeriod(null)



                }



            }).catch(() => {})



        },



        handlePeriodNav (index) {



            if (!this.lotteryActive) return



            if (index === 0) {



                this.initPeriod()



                return



            }



            if (!this.periodId) {



                this.$message.warning('暂无期次')



                return



            }



            const direction = index === 1 ? 'prev' : 'next'



            getAdjacentPeriod({



                preType: this.lotteryActive,



                periodId: this.periodId,



                direction



            }).then(res => {



                if (res && res.code === 200 && res.data) {



                    this.applyPeriod(res.data)



                } else if (index === 1) {



                    this.$message.warning('没有上一期了')



                } else {



                    this.$message.warning('已经是最新期')



                }



            }).catch(() => {})



        },



        toggleLottery (val) {



            if (this.lotteryActive === val) return



            this.lotteryActive = val



            this.$router.replace({



                path: this.$route.path,



                query: Object.assign({}, this.$route.query, { preType: val })



            }).catch(() => {})



            this.initPeriod()



        },



        goSubmit () {



            if (!this.periodOperable) {



                this.$message.warning('本期已截止，无法提交')



                return



            }



            if (!this.vuex_token) {



                this.$router.push('/login?redirect=' + encodeURIComponent('/hxwysz/submit?preType=' + this.lotteryActive))



                return



            }



            this.$router.push({ path: '/hxwysz/submit', query: { preType: this.lotteryActive } })



        }



    }



}



</script>







<style lang="scss" scoped>



@import "./audition.scss";



</style>


